import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Spin, Alert } from 'antd';
import API from '../../../services';
import './forecast.css'; // Add custom CSS for mobile styling

const FuelForecast = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  
  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Check for dark mode preference
    const checkDarkMode = () => {
      setIsDarkMode(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
    };

    checkMobile();
    checkDarkMode();

    window.addEventListener('resize', checkMobile);
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', checkDarkMode);

    return () => {
      window.removeEventListener('resize', checkMobile);
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', checkDarkMode);
    };
  }, []);

  useEffect(() => {
    const fetchForecast = async () => {
      try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await API.FmsGetForcast({}, timezone);
        if (response) {

          // Transform data for chart
          const chartData = response.map(item => ({
            date: item.date_format,
            Actual: item.Fuel_Actual_Total?.toFixed(2),
            Forecast: item.Fuel_Forecast?.toFixed(2),
            Predicted: item.Fuel_Predicted_Total?.toFixed(2),
          }));

          setData(chartData);

        } else {
          setError('No data received from API');
        }
      } catch (err) {
        setError('Failed to fetch forecast data');
        console.error('Error fetching forecast:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchForecast();
  }, []);

  const chartHeight = isMobile ? 300 : 400;

  return (
    <>
      <div className="container-fluid white-back-cr">
        <div className="container mt-3 fuel-forecast-container">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <Spin size="large" />
            </div>
          ) : error ? (
            <Alert message={error} type="error" />
          ) : data && data.length > 0 ? (
            <>
              <div className="fuel-forecast-chart">
              <ResponsiveContainer width="100%" height={chartHeight}>
                <LineChart
                  data={data}
                  margin={isMobile ? { top: 20, right: 10, left: 0, bottom: 20 } : { top: 20, right: 30, left: 5, bottom: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="date"
                      tick={{ fontSize: isMobile ? 10 : 12 }}
                      angle={isMobile ? -45 : 0}
                      textAnchor={isMobile ? 'end' : 'middle'}
                      height={isMobile ? 60 : 30}
                    />
                    <YAxis tick={{ fontSize: isMobile ? 10 : 12 }} />
                    <Tooltip
                      contentStyle={{
                        fontSize: isMobile ? '12px' : '14px',
                        padding: isMobile ? '8px' : '10px'
                      }}
                    />
                    <Legend
                      wrapperStyle={{
                        fontSize: isMobile ? '12px' : '14px',
                        paddingTop: isMobile ? '10px' : '20px'
                      }}
                    />
                    <Line type="monotone" dataKey="Actual" stroke="#8884d8" strokeWidth={isMobile ? 1.5 : 2} />
                    <Line type="monotone" dataKey="Forecast" stroke="#82ca9d" strokeWidth={isMobile ? 1.5 : 2} />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '50px' }}>
              <p>No forecast data available</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FuelForecast;
